import { ModalNavigationEnum } from '../../../shared/constants';

export const IntentSettingsVerticalTabParam: string = `${ModalNavigationEnum.INTENT_SETTINGS}.vertical-tab-menu`;
export const IntentSettingsHorizontalMenu: string = `${ModalNavigationEnum.INTENT_SETTINGS}.horizontal-tab-menu`;
export const IntentSettingsNewAutomationTypeParam: string = `${ModalNavigationEnum.INTENT_SETTINGS}.new-automation-type`;
export const IntentSettingsAutomationNameToScrollParam: string = `${ModalNavigationEnum.INTENT_SETTINGS}.automation-name-to-scroll`;
export const INTENT_AUTOMATION_SAVED_SEARCH_ID: string = `${ModalNavigationEnum.INTENT_SETTINGS}.saved-search-id`;
